module.exports = __webpack_public_path__ + "img/login.da7ba2a0.jpg";